import { differenceInHours } from 'date-fns';

export function differenceInDaysIgnoreTimezone(laterDate: string, earlierDate: string): number {
	// because date-fns is affected by timezone changes, using differenceInDays caused an issue whereby if one of the included days had less than 24 hours (i.e. DST "spring forward" day),
	// the result was one day less than expected, because differenceInDays only considers whole days (days that consist of 24 hours),
	// hence needing this function to work it out at hour granularity and round accordingly
	return Math.round(differenceInHours(laterDate, earlierDate) / 24); // this will round up for "spring forward" and round down for "fall back"
}